import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = ["input", "dropzone", "previews", "hiddenFields", "submit"]
  static values = { url: String }

  browse() {
    this.inputTarget.click()
  }

  inputChanged(event) {
    this.handleFiles(event.target.files)
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-primary")
  }

  dragleave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-primary")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-primary")
    this.handleFiles(event.dataTransfer.files)
  }

  handleFiles(fileList) {
    Array.from(fileList).forEach(file => this.uploadFile(file))
  }

  uploadFile(file) {
    const preview = this.addPreview(file)
    const upload = new DirectUpload(file, this.urlValue, {
      directUploadWillStoreFileWithXHR: (request) => {
        request.upload.addEventListener("progress", (event) => {
          const progress = (event.loaded / event.total) * 100
          preview.querySelector("[data-role='progress']").style.width = `${progress}%`
        })
      }
    })

    upload.create((error, blob) => {
      if (error) {
        preview.querySelector("[data-role='status']").textContent = "Failed"
        preview.classList.add("text-error")
      } else {
        preview.querySelector("[data-role='status']").textContent = "Ready"
        preview.querySelector("[data-role='progress']").style.width = "100%"
        this.addHiddenField(blob.signed_id)
        this.submitTarget.disabled = false
      }
    })
  }

  addPreview(file) {
    const div = document.createElement("div")
    div.classList.add("flex", "items-center", "gap-2", "py-1")
    div.innerHTML = `
      <span class="text-sm truncate flex-1">${file.name}</span>
      <span data-role="status" class="text-xs opacity-60">Uploading...</span>
      <div class="w-24 bg-base-300 rounded-full h-2">
        <div data-role="progress" class="bg-primary h-2 rounded-full transition-all" style="width: 0%"></div>
      </div>
    `
    this.previewsTarget.appendChild(div)
    return div
  }

  addHiddenField(signedId) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "documents[]"
    input.value = signedId
    this.hiddenFieldsTarget.appendChild(input)
  }
}
